// GENERATED FILE — do not edit by hand.
// Source of truth: libs/design-tokens/tokens/*.tokens.json (DTCG format).
// Rebuild with: npm run tokens:build
export const designTokens = {
	"color": {
		"blue": {
			"25": "#e6f4ff",
			"50": "#d6edff",
			"100": "#b1dcff",
			"200": "#8acbff",
			"300": "#71c0ff",
			"400": "#51a8ff",
			"500": "#278df3",
			"600": "#007ae8",
			"700": "#0560b4",
			"800": "#00539f",
			"900": "#00417c"
		},
		"gray": {
			"25": "#f8f9fe",
			"50": "#f2f4fb",
			"100": "#e0e3f1",
			"200": "#d0d3e4",
			"300": "#bbc0d3",
			"400": "#979cb2",
			"500": "#78819b",
			"600": "#626a82",
			"700": "#51586e",
			"800": "#3f465a",
			"900": "#2d3449"
		},
		"orange": {
			"25": "#fdf3ed",
			"50": "#ffe9dc",
			"100": "#ffcfb3",
			"200": "#ffb488",
			"300": "#ff975f",
			"400": "#ff823d",
			"500": "#fe6401",
			"600": "#f55e0c",
			"700": "#ea5403",
			"800": "#d14a02",
			"900": "#ab3c00"
		},
		"lime": {
			"25": "#f7fce7",
			"50": "#effbc7",
			"100": "#e6fba2",
			"200": "#d5f879",
			"300": "#b9eb5b",
			"400": "#97de11",
			"500": "#84cc00",
			"600": "#77b800",
			"700": "#659c00",
			"800": "#578602",
			"900": "#466c00"
		},
		"purple": {
			"25": "#f3e9f9",
			"50": "#e9ddf0",
			"100": "#d9c1e9",
			"200": "#bb97d1",
			"300": "#a57fbe",
			"400": "#966bb1",
			"500": "#82589d",
			"600": "#6e4687",
			"700": "#653c7f",
			"800": "#572f71",
			"900": "#46215e"
		},
		"red": {
			"50": "#fde8e8",
			"500": "#cb4040",
			"700": "#bc2c2c"
		},
		"yellow": {
			"200": "#ffee4e",
			"400": "#febf3c"
		},
		"green": {
			"500": "#59c50a"
		},
		"black": "#000000",
		"white": "#ffffff",
		"brand": {
			"primary": "#007ae8",
			"mark": "#1f4a9c"
		},
		"status": {
			"danger": "#cb4040",
			"danger-emphasis": "#bc2c2c",
			"danger-surface": "#fde8e8",
			"warning": "#febf3c",
			"success": "#59c50a",
			"info": "#007ae8"
		},
		"overlay": {
			"scrim": "#000000bf",
			"scrim-light": "#00000099"
		},
		"legacy": {
			"blue": "#00539f",
			"gray": "#78819b",
			"orange": "#fe6401",
			"lime": "#77b800"
		}
	},
	"spacing": {
		"0": "0",
		"2": "2px",
		"4": "4px",
		"8": "8px",
		"12": "12px",
		"16": "16px",
		"20": "20px",
		"24": "24px",
		"32": "32px",
		"40": "40px",
		"48": "48px",
		"64": "64px"
	},
	"radius": {
		"none": "0",
		"xs": "2px",
		"sm": "4px",
		"md": "8px",
		"lg": "12px",
		"xl": "16px",
		"2xl": "28px",
		"full": "9999px"
	},
	"breakpoint": {
		"small": "48em",
		"medium": "64em",
		"large": "85.375em",
		"xlarge": "120em",
		"xxlarge": "160em"
	},
	"shadow": {
		"xs": {
			"offsetX": "0",
			"offsetY": "1px",
			"blur": "2px",
			"spread": "0",
			"color": "rgba(0, 0, 0, 0.15)"
		},
		"sm": {
			"offsetX": "0",
			"offsetY": "1px",
			"blur": "3px",
			"spread": "0",
			"color": "rgba(0, 0, 0, 0.2)"
		},
		"md": {
			"offsetX": "0",
			"offsetY": "2px",
			"blur": "8px",
			"spread": "0",
			"color": "rgba(0, 0, 0, 0.2)"
		},
		"lg": {
			"offsetX": "0",
			"offsetY": "8px",
			"blur": "15px",
			"spread": "0",
			"color": "rgba(0, 0, 0, 0.15)"
		}
	},
	"opacity": {
		"state": {
			"hover": 0.08,
			"focus": 0.12,
			"pressed": 0.12,
			"dragged": 0.16
		}
	},
	"font": {
		"family": {
			"base": "Roboto",
			"icons": "NHAIcons"
		},
		"weight": {
			"thin": 100,
			"light": 300,
			"regular": 400,
			"medium": 500,
			"bold": 700,
			"black": 900
		},
		"size": {
			"xs": "11px",
			"sm": "13px",
			"md": "14px",
			"lg": "16px",
			"xl": "18px",
			"2xl": "22px",
			"3xl": "24px",
			"4xl": "32px",
			"5xl": "44px"
		}
	},
	"typography": {
		"largeHeadline": {
			"400": {
				"fontFamily": "Roboto",
				"fontWeight": 400,
				"fontSize": "22px"
			},
			"500": {
				"fontFamily": "Roboto",
				"fontWeight": 500,
				"fontSize": "22px"
			},
			"700": {
				"fontFamily": "Roboto",
				"fontWeight": 700,
				"fontSize": "24px"
			},
			"800": {
				"fontFamily": "Roboto",
				"fontWeight": 400,
				"fontSize": "32px"
			},
			"900": {
				"fontFamily": "Roboto",
				"fontWeight": 700,
				"fontSize": "44px"
			}
		},
		"mediumHeadline": {
			"400": {
				"fontFamily": "Roboto",
				"fontWeight": 400,
				"fontSize": "18px"
			},
			"500": {
				"fontFamily": "Roboto",
				"fontWeight": 500,
				"fontSize": "18px"
			}
		},
		"smallHeadline": {
			"400": {
				"fontFamily": "Roboto",
				"fontWeight": 400,
				"fontSize": "16px"
			},
			"500": {
				"fontFamily": "Roboto",
				"fontWeight": 500,
				"fontSize": "16px"
			}
		},
		"buttonText": {
			"400": {
				"fontFamily": "Roboto",
				"fontWeight": 400,
				"fontSize": "14px"
			},
			"500": {
				"fontFamily": "Roboto",
				"fontWeight": 500,
				"fontSize": "16px"
			}
		},
		"largeText": {
			"400": {
				"fontFamily": "Roboto",
				"fontWeight": 400,
				"fontSize": "16px"
			},
			"500": {
				"fontFamily": "Roboto",
				"fontWeight": 500,
				"fontSize": "16px"
			},
			"700": {
				"fontFamily": "Roboto",
				"fontWeight": 700,
				"fontSize": "16px"
			}
		},
		"normalText": {
			"400": {
				"fontFamily": "Roboto",
				"fontWeight": 400,
				"fontSize": "14px"
			},
			"500": {
				"fontFamily": "Roboto",
				"fontWeight": 500,
				"fontSize": "14px"
			},
			"700": {
				"fontFamily": "Roboto",
				"fontWeight": 700,
				"fontSize": "14px"
			}
		},
		"smallText": {
			"300": {
				"fontFamily": "Roboto",
				"fontWeight": 300,
				"fontSize": "13px"
			},
			"400": {
				"fontFamily": "Roboto",
				"fontWeight": 400,
				"fontSize": "13px"
			},
			"500": {
				"fontFamily": "Roboto",
				"fontWeight": 500,
				"fontSize": "13px"
			},
			"700": {
				"fontFamily": "Roboto",
				"fontWeight": 700,
				"fontSize": "13px"
			}
		},
		"tinyText": {
			"300": {
				"fontFamily": "Roboto",
				"fontWeight": 300,
				"fontSize": "11px"
			},
			"400": {
				"fontFamily": "Roboto",
				"fontWeight": 400,
				"fontSize": "11px"
			},
			"500": {
				"fontFamily": "Roboto",
				"fontWeight": 500,
				"fontSize": "11px"
			},
			"700": {
				"fontFamily": "Roboto",
				"fontWeight": 700,
				"fontSize": "11px"
			}
		}
	}
} as const;
